import { ChangeEvent, DragEvent, useRef, useState, useEffect } from "react";
import { BCButton, BCInputFileTitleIcon } from "../../../styled/global.styled";
import BcIcon from '../../Bc-Icon/Bc-icon';
import { Filetype } from "../../../enums/files.enums";
import { UseFormRegister, UseFormResetField, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { FormBase } from "../../../interface/form-base";
import BcModal from "../../Bc-Modal/Bc-Modal";
import PropTypes from 'prop-types';


interface Props {
    field: FormBase;
    fileTypes: string [];
    maxSize: number;
    maxRegister?: number;
    register: UseFormRegister<any>;
    setValue: UseFormSetValue<any>;
    resetField: UseFormResetField<any>;
    isRequired: boolean;
    multiFile?: boolean;
    watch: UseFormWatch<any>;
}

const FileField = ({fileTypes, maxSize, maxRegister, field, setValue, register, isRequired, resetField, multiFile, watch }: Props) => {

  const [file, setFile] = useState<FileList | null>(null);
  const [openDiag, setOpenDiag] = useState<boolean>(false);
  const valueFiles = watch(field.item);
  const acceptFile = fileTypes.map((word: string) => `.${word}`).join(",");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleModal = () => {
    setOpenDiag(!openDiag);
  };
  
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleReset = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      resetField(field.item);
      setFile(null);
    }
  };

  useEffect(() => {
    if (valueFiles === undefined) {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        setFile(null);
      }
    }
  }, [valueFiles]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    
    if (files) {
      setValue(field.item, files);
      saveFiles(files);
    }
  };

  const handleDrag = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add("bc-drop-area-hover");
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("bc-drop-area-hover");
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("bc-drop-area-hover");
    e.target.files = e.dataTransfer.files;
    console.log(e.target.files);
    const files = e.target.files;
    console.log(files);
    saveFiles(files);
  };

  const validTypeDoc = (type: any): boolean => {
    const typeValues = Object.values(Filetype);
    return typeValues.includes(type);
  };

  const saveFiles = (files: FileList) => {
    if (files) {
      if (validTypeDoc(files[0].type)) {
        setValue(field.item, files, { shouldValidate: true })
        setFile(files);
      } else {
        handleModal();
        handleReset();
      }
      }
  };

  return (
    <div className="bc-input-file" id={field.item}>
      <div className="bc-input-file-header center">
        <h6>{field.label}</h6>
      </div>
      <div
        className="bc-drop-area"
        aria-label="Adjuntar archivos"
        onDrop={handleDrop}
        onDragOver={handleDrag}
        onDragEnter={handleDrag}
        onDragLeave={handleDragLeave}
      > 
        <BCInputFileTitleIcon className="bc-none bc-md-block">
            <BcIcon iconName="cloud-upload" size="bc-md" />
          <p>Arrastra aquí los archivos desde tu computador o</p>
        </BCInputFileTitleIcon>
        <div className="bc-container-button-input-file">
          <button
            onClick={handleClick}
            className="bc-button-secondary bc-button-small bc-button-select-file"
          >
            Agregar archivo
          </button>
          <input
            className="bc-none bc-drop-area-input"
            id="fileFieldCustom"
            type="file"
            multiple={multiFile}
            tabIndex={0}
            accept={acceptFile}
            {...register(field.item, { onChange: (e) => {handleFileChange(e)}, required: isRequired })}
            ref={fileInputRef}
          />
        </div>
        <div className="bc-container-info-files">
          <span className="bc-info-files-type">
            {maxRegister && <span>Puede contener máximo {maxRegister} registros.</span>} Los formatos permitidos son {
                fileTypes.map((file: string) => <em key={file}> .{file.toUpperCase()}</em>)
            }
          </span>
          <span className="bc-info-files-size">con un peso de {maxSize} MB máximo</span>
        </div>
      </div>
      <div className="bc-files-container bc-mb-3">
        {file &&
          Array.from(file).map((file, index) => (
            <div className="bc-uploaded-file bc-uploaded-file-success" key={file.name}>
              <div className="bc-file-left">
                <BcIcon iconName="successful" />
              </div>
              <div className="bc-file-center">
                <div className="bc-info">
                  <div className="bc-info-name bc-info-name-final">
                    <p>
                      <strong>{file.name}</strong>
                    </p>
                  </div>
                  <div className="bc-info-size">
                    <section className="bc-info-load bc-info-load-success">
                      {(file.size / 1024).toFixed(2)} Kb / Listo
                    </section>
                    <section className="bc-info-percent"></section>
                  </div>
                </div>
              </div>
              <div className="bc-input-refresh"></div>
              <div className="bc-file-right">
                <button title="reset" className="bc-fab-btn-icon file-button" tabIndex={0} onClick={handleReset}>
                  <BcIcon iconName="error" />
                </button>
              </div>
            </div>
          ))}
      </div>
      <div className="bc-files-show-more-container bc-none"></div>
      <BcModal
        openModal={openDiag}
        type="error"
        title="Formato de archivo no permitido"
        onClose={handleModal}
      >
        <section className="bc-modal-content">
          <div>
            <p>
              El formato que acabas de ingresar no es valido, recuerda que los formatos validos son: <strong>{acceptFile}</strong>
            </p>
          </div>
        </section>
        <section className="bc-modal-button-container">
          <BCButton className="bc-button-primary bc-button-small" tabIndex={0} onClick={handleModal}>
            Aceptar
          </BCButton>
        </section>
      </BcModal>
    </div>
  );
};

export default FileField;

FileField.propTypes = {
  fileTypes: PropTypes.array ,
  maxSize: PropTypes.number,
}

FileField.defaultProps = {
    fileTypes: ['png', 'jpeg', 'jpg'],
    maxSize: 25,
}
